'use strict';

import DefaultDict from '../utils/defaultDict';

class MessageManager {
  constructor(store) {
    let self = this;
    this._handlerMap = {
      ack: (event_data) => self._handleAck(event_data),
      initial_state: (event_data) => self._handleInitialState(event_data),
      alert: (event_data) => self._handleNotification(event_data),
      update_alert: (event_data) => self._handleUpdateAlert(event_data),
      clear_alert: (event_data) => self._handleClearAlert(event_data),
      metric: (event_data) => self._handleMetric(event_data),
      chain_metric: (event_data) => self._handleMetric(event_data),
    };
    this.store = store;
  }
  receiveMessage(event_data) {
    let self = this;
    event_data.forEach((event) => {
      if (event.message in self._handlerMap) {
        // Ignore unknown messages
        let handler = this._handlerMap[event.message];
        handler(event);
      }
    });
  }
  _handleAck() {}
  _handleInitialState(event_data) {
    console.log('_handleInitialState event_data =', event_data);

    // Create maps for alerts by source
    let alertsByNode = new DefaultDict.DefaultDict(() => []);
    let alertsByChain = new DefaultDict.DefaultDict(() => []);

    event_data.alerts.forEach((alert) => {
      if (alert.source_type === 'node') {
        alertsByNode[alert.source_id].push(alert);
      } else if (alert.source_type === 'chain') {
        alertsByChain[alert.source_id].push(alert);
      }
    });

    // Process nodes and attach their alerts
    let nodesByChain = new DefaultDict.DefaultDict(() => []);
    let nodes = event_data.nodes.map((node) =>
      Object.assign({}, node, { alerts: alertsByNode[node.id] })
    );
    nodes.forEach((node) => {
      nodesByChain[node.chain_id].push(node);
    });

    // Process chains and attach both nodes and chain-level alerts
    let chains = event_data.chains.map((chain) =>
      Object.assign({}, chain, {
        nodes: nodesByChain[chain.id],
        alerts: alertsByChain[chain.id] || [],
      })
    );

    this.store.dispatch('initialiseChains', chains);
    this.store.dispatch('initialiseTables');
    this.store.dispatch('initialiseIngestors', event_data.ingestors);
    this.store.dispatch('initialiseMetrics2', event_data.metrics);
    this.store.dispatch('setLastMessageId', event_data.id);
    this.store.dispatch('removeAllNotifications');

    // Process settings data from initial state
    if (event_data.settings && Array.isArray(event_data.settings)) {
      this.store.dispatch('initialiseSettings', event_data.settings);
    }

    event_data.active_alerts.forEach((alert) => {
      this.store.dispatch('createNotification', {
        message: 'alert',
        data: alert,
      });
    });

    this.store.dispatch('setVersion', event_data);
  }
  _handleNotification({ message, data }) {
    console.log('Notification received =', data);
    this.store.dispatch('createNotification', { message, data });
  }
  _handleUpdateAlert(event_data) {
    console.log('Update alert received =', event_data);
    this.store.dispatch('updateNotification', event_data.data);
  }
  _handleClearAlert(event_data) {
    console.log('Clear alert received =', event_data);
    this.store.dispatch('archiveNotifications', {
      source: event_data.source,
      metric: event_data.metric,
      url: event_data.url,
    });
  }
  _handleMetric(event_data) {
    if (event_data.message == 'chain_metric') {
      // Chain-level metric
      this.store.dispatch('setChainMetric', {
        chain_id: event_data.metric.chain_id,
        metric_name: event_data.metric.metric_name,
        value: event_data.metric.value,
      });
    } else if (event_data.message == 'metric' && event_data.metric.alert_id) {
      // Node-level metric (existing logic)
      this.store.dispatch('setMetric', {
        alert_id: event_data.metric.alert_id,
        value: event_data.metric.value,
      });
    } else {
      console.log('Unhandled metric type:', event_data);
    }
  }
}

function initizeMessageManager(store) {
  return new MessageManager(store);
}

export default { initizeMessageManager };
